export default {
    typeSubscriptionIndex: { method: 'get', url: 'signatures/type-subscriptions' },
    typeInstitutionSubscriptionIndex: { method: 'get', url: 'signatures/type-institution-subscriptions' },
    typeInstitutionSubscriptionStore: { method: 'post', url: 'signatures/type-institution-subscriptions' },
    typeInstitutionSubscriptionUpdate: { method: 'put', url: 'signatures/type-institution-subscriptions/{id}' },
    typeInstitutionSubscriptionDestroy: { method: 'delete', url: 'signatures/type-institution-subscriptions/{id}' },
}